import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BYPASS_ERROR } from 'app/core/interceptors/error.interceptor';
import { INotificationDecision, INotificationResponse, IReadNotificationResponse } from 'app/core/interfaces/notification.interface';
import { IPaginatedResponse } from 'app/shared/interfaces/IPagination';
import { Observable, map } from 'rxjs';

const baseUrl = environment.apiHost;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private readonly http = inject(HttpClient);

  getNotifications(
    page: number = 1,
    size: number = 5,
  ): Observable<{ items: INotificationResponse[]; total: number }> {
    let params = new HttpParams()
      .set('page', String(page))
      .set('size', String(size))
      .set('read', true);

    return this.http
      .get<IPaginatedResponse<INotificationResponse> | INotificationResponse[]>(
        `${baseUrl}/Notification/list`,
        { params }
      )
      .pipe(
        map((resp: any) => {
          if (Array.isArray(resp)) {
            return { items: resp as INotificationResponse[], total: resp.length };
          }

          const items: INotificationResponse[] = resp?.items ?? [];
          const total: number = (
            resp?.totalItems ?? 
            resp?.total ?? 
            resp?.totalCount ?? 
            items.length
          );
          return { items, total };
        })
      );
  }

  getUnreadNotifications(): Observable<IReadNotificationResponse> {
    //Solución temporal, eliminar cuando se implemente el cierre de sesión por expiración del token 
    const context = new HttpContext()
      .set(BYPASS_ERROR, true);

    return this.http.get<IReadNotificationResponse>(`${baseUrl}/Notification/unread`, { context });
  }
  
  postWorkspace(items: INotificationDecision) {
    return this.http.post(`${baseUrl}/Notification/setStatus `, items);
  }

}
